module.exports = __webpack_public_path__ + "static/img/wangguowen.9db4429.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/summit/wangguowen.png
// module id = Jv8U
// module chunks = 1